import { render, staticRenderFns } from "./FormBlockDrop.vue?vue&type=template&id=c1955a8e&scoped=true&"
import script from "./FormBlockDrop.vue?vue&type=script&lang=js&"
export * from "./FormBlockDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1955a8e",
  null
  
)

export default component.exports